import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/presentation';
import { fetchingState } from '../../constants';

const initialStats = {
  documentList: {},
  document: {},
  globalDocumentList: {},
  presentationList: {},
  finalPresentationList: {},
  spinner: {
    propertyPDF: false,
    globalPDF: false,
    presentation: false,
    publishedPDF: false,
    generate: false,
  },
  uploading: '',
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.PRESENTATION_DOCUMENTLIST_FETCH_START:
      return state.setIn(['documentList', 'state'], fetchingState.FETCHING);
    case actions.PRESENTATION_DOCUMENTLIST_FETCH_SUCCESS:
      let newState = state.setIn(
        ['documentList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['documentList', 'data'],
        fromJS(action.data?.results || []),
      );
    case actions.PRESENTATION_DOCUMENTLIST_FETCH_ERROR:
      return state.setIn(['documentList', 'state'], fetchingState.ERROR);

    case actions.PRESENTATION_GLOBALDOCUMENTLIST_FETCH_START:
      return state.setIn(
        ['globalDocumentList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.PRESENTATION_GLOBALDOCUMENTLIST_FETCH_SUCCESS:
      newState = state.setIn(
        ['globalDocumentList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['globalDocumentList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PRESENTATION_GLOBALDOCUMENTLIST_FETCH_ERROR:
      return state.setIn(['globalDocumentList', 'state'], fetchingState.ERROR);

    case actions.PRESENTATION_DOCUMENT_DELETE_SUCCESS:
      let newDocumentList = state.getIn(['documentList', 'data']).toJS();
      newDocumentList = newDocumentList.filter(
        (document) => document.documentID !== action.documentId,
      );
      return state.setIn(['documentList', 'data'], fromJS(newDocumentList));

    case actions.PRESENTATION_GLOBALDOCUMENT_DELETE_SUCCESS:
      let newGlobalDocumentList = state
        .getIn(['globalDocumentList', 'data'])
        .toJS();
      newGlobalDocumentList = newGlobalDocumentList.filter(
        (document) => document.documentID !== action.documentId,
      );
      return state.setIn(
        ['globalDocumentList', 'data'],
        fromJS(newGlobalDocumentList),
      );

    case actions.PRESENTATION_GLOBALDOCUMENT_UPLOAD_START:
      return state.setIn(['uploading'], fetchingState.FETCHING);
    case actions.PRESENTATION_GLOBALDOCUMENT_UPLOAD_SUCCESS:
      newState = state.setIn(['uploading'], fetchingState.LOADED);
      return newState.setIn(
        ['globalDocumentList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PRESENTATION_GLOBALDOCUMENT_UPLOAD_ERROR:
      return state.setIn(['uploading'], fetchingState.ERROR);

    case actions.PRESENTATION_DOCUMENT_UPLOAD_START:
      return state.setIn(['uploading'], fetchingState.FETCHING);
    case actions.PRESENTATION_DOCUMENT_UPLOAD_SUCCESS:
      newState = state.setIn(['uploading'], fetchingState.LOADED);
      return newState.setIn(
        ['documentList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PRESENTATION_DOCUMENT_UPLOAD_ERROR:
      return state.setIn(['uploading'], fetchingState.ERROR);

    case actions.PRESENTATION_DOCUMENT_GET_SUCCESS:
    case actions.PRESENTATION_GLOBALDOCUMENT_GET_SUCCESS:
      newState = state.setIn(['spinner', action.openIn], false);
      return newState.setIn(
        ['document', action.documentId],
        fromJS(action.data),
      );

    case actions.PRESENTATION_FETCH_START:
      return state.setIn(['presentationList', 'state'], fetchingState.FETCHING);
    case actions.PRESENTATION_FETCH_SUCCESS:
      newState = state.setIn(
        ['presentationList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['presentationList', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.PRESENTATION_FETCH_ERROR:
      return state.setIn(['presentationList', 'state'], fetchingState.ERROR);

    case actions.PRESENTATION_DELETE_SUCCESS:
      let newPresentationList = state
        .getIn(['presentationList', 'data'])
        .toJS();
      newPresentationList = newPresentationList.filter(
        (presentation) => presentation.ID !== action.presentationId,
      );
      return state.setIn(
        ['presentationList', 'data'],
        fromJS(newPresentationList),
      );

    case actions.PRESENTATION_FINAL_PRESENTATION_FETCH_START:
      return state.setIn(
        ['finalPresentationList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.PRESENTATION_FINAL_PRESENTATION_FETCH_SUCCESS:
      newState = state.setIn(
        ['finalPresentationList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['finalPresentationList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PRESENTATION_FINAL_PRESENTATION_FETCH_ERROR:
      return state.setIn(
        ['finalPresentationList', 'state'],
        fetchingState.ERROR,
      );

    case actions.PRESENTATION_PUBLISH_SUCCESS:
      return state.setIn(
        ['finalPresentationList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.PRESENTATION_DRAG_ITEM:
      newPresentationList = state.getIn(['presentationList', 'data']).toJS();
      const dragItem = newPresentationList[action.data.dragIndex];
      newPresentationList.splice(action.data.dragIndex, 1);
      newPresentationList.splice(action.data.hoverIndex, 0, dragItem);
      return state.setIn(
        ['presentationList', 'data'],
        fromJS(newPresentationList),
      );

    case actions.PRESENTATION_GLOBAL_DOCUMENT_ADD_SUCCESS:
    case actions.PRESENTATION_PUBLISHED_DOCUMENT_ADD_SUCCESS:
      return state.setIn(
        ['presentationList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.PRESENTATION_DOCUMENT_GET_START:
    case actions.PRESENTATION_GLOBALDOCUMENT_GET_START:
      return state.setIn(['spinner', action.openIn], true);

    case actions.PRESENTATION_DOCUMENT_GET_ERROR:
    case actions.PRESENTATION_GLOBALDOCUMENT_GET_ERROR:
      return state.setIn(['spinner', action.openIn], false);

    case actions.PRESENTATION_FINAL_DOCUMENT_GET_START:
      return state.setIn(['spinner', 'publishedPDF'], true);
    case actions.PRESENTATION_FINAL_DOCUMENT_GET_SUCCESS:
      return state.setIn(['spinner', 'publishedPDF'], false);
    case actions.PRESENTATION_FINAL_DOCUMENT_GET_ERROR:
      return state.setIn(['spinner', 'publishedPDF'], false);

    case actions.PRESENTATION_PREVIEW_START:
      return state.setIn(['spinner', 'presentation'], true);
    case actions.PRESENTATION_PREVIEW_SUCCESS:
      return state.setIn(['spinner', 'presentation'], false);
    case actions.PRESENTATION_PREVIEW_ERROR:
      return state.setIn(['spinner', 'presentation'], false);

    case actions.PRESENTATION_TEMPLATE_CREATE_START:
      return state.setIn(['spinner', 'generate'], true);
    case actions.PRESENTATION_TEMPLATE_CREATE_SUCCESS:
      newState = state.setIn(['spinner', 'generate'], false);
      return newState.setIn(
        ['presentationList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.PRESENTATION_TEMPLATE_CREATE_ERROR:
      return state.setIn(['spinner', 'generate'], false);
    default:
      return state;
  }
};
